import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
export var Tooltip = function (_a) {
    var title = _a.title, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, children = _a.children;
    var _c = useState(false), isVisible = _c[0], setIsVisible = _c[1];
    var _d = useState(placement), adjustedPlacement = _d[0], setAdjustedPlacement = _d[1];
    var tooltipRef = useRef(null);
    var positionClasses = {
        top: 'bottom-full left-0 mb-2',
        bottom: 'top-full left-0 mt-2',
        left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
    };
    useEffect(function () {
        if (isVisible && tooltipRef.current) {
            var tooltipRect = tooltipRef.current.getBoundingClientRect();
            var viewportWidth = window.innerWidth;
            var viewportHeight = window.innerHeight;
            if (placement === 'top' && tooltipRect.top < 0) {
                setAdjustedPlacement('bottom');
            }
            else if (placement === 'bottom' && tooltipRect.bottom > viewportHeight) {
                setAdjustedPlacement('top');
            }
            else if (placement === 'left' && tooltipRect.left < 0) {
                setAdjustedPlacement('right');
            }
            else if (placement === 'right' && tooltipRect.right > viewportWidth) {
                setAdjustedPlacement('left');
            }
            else {
                setAdjustedPlacement(placement);
            }
        }
    }, [isVisible, placement]);
    return (_jsxs("div", { className: 'relative flex items-center', onMouseEnter: function () { return setIsVisible(true); }, onMouseLeave: function () { return setIsVisible(false); }, children: [children, isVisible && (_jsxs("div", { ref: tooltipRef, className: "absolute z-100000 px-2 py-1 text-xs font-medium text-white bg-gray-800 rounded shadow-lg whitespace-nowrap ".concat(positionClasses[adjustedPlacement]), children: [title, _jsx("div", { className: "absolute w-2 h-2 bg-gray-800 rotate-45 ".concat(adjustedPlacement === 'top' ? 'bottom-0 left-2 translate-y-1' : '', " ").concat(adjustedPlacement === 'bottom' ? 'top-0 left-2 -translate-y-1' : '', " ").concat(adjustedPlacement === 'left'
                            ? 'right-0 top-1/2 transform -translate-y-1/2 translate-x-1'
                            : '', " ").concat(adjustedPlacement === 'right'
                            ? 'left-0 top-1/2 transform -translate-y-1/2 -translate-x-1'
                            : '') })] }))] }));
};
